module.exports = __webpack_public_path__ + "static/media/tree-step-5_4.0c24d4e9.svg";